<template>
    <div class="sbscr_wrap">
        <div class="inner">
            <p>뉴스레터 구독신청
                <br/>춘천 도시재생지원센터 뉴스레터를 구독신청합니다.</p>
            <a v-if="mode !== 'preview'" href="#" class="btn_basic" @click="subscribeHandle">신청하기</a>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "WebZineViewFooterSubscribe",
    computed:{
      ...mapGetters('webzineView', [
          'mode',
          'isPreview'
      ])
    },
    methods:{
        ...mapActions('webzineView', [
            'subscribe'
        ]),
        subscribeHandle(){
            this.$prompt('이메일 주소를 입력해주세요', '', {
                confirmButtonText: '확인',
                cancelButtonText: '취소',
                inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                inputErrorMessage: '이메일 형식이 올바르지 않습니다.'
            }).then(({ value }) => {
                const loading = this.$cmmLoading();
                this.subscribe(value)
                    .then(() => this.$successMessage('이메일을 성공적으로 등록했습니다.'))
                    .catch(() => this.$errorMessage('뉴스레터 구독 신청 중에 에러가 발생했습니다. 잠시 후 다시 시도해주세요.'))
                    .finally(()=> loading.close());
            });
        }
    }
}
</script>

<style scoped>

</style>
